<template>
  <b-modal
    ref="loading-quotation-modal"
    id="loading-quotation-modal"
    size="sm"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-header
    hide-header-close
    hide-footer
    :visible="isLoadingQuotationToTool"
  >
    <template slot="default">
      <div class="text-center">
        Uw offerte wordt in de tool geladen
        <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed: {
      isLoadingQuotationToTool() {
        return this.$store.getters.isLoadingQuotationToTool
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
